class Exam {
    constructor(apiService = null) {
        this.obj_name = 'exam';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                // GET 請求
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                // POST 請求
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // API 方法
    //檢驗 | 101新增外部檢驗
    async addExaminationResultOutside(parameter, progressEvent = null) {
        return this.callApi('post', 'addExaminationResultOutside', parameter, progressEvent);
    }
    //檢驗 | 102新增內部檢驗
    async addExaminationResultInside(parameter, progressEvent = null) {
        return this.callApi('post', 'addExaminationResultInside', parameter, progressEvent);
    }
    //檢驗 | 103搜尋檢驗紀錄
    async getExaminationByCreateTime(parameter) {
        return this.callApi('get', 'getExaminationByCreateTime', parameter);
    }
    //檢驗 | 104取得檢驗列表
    async getExamOutsideStatusByExamTypeAndKeywordWithPage(parameter) {
        return this.callApi('get', 'getExamOutsideStatusByExamTypeAndKeywordWithPage', parameter);
    }
    //檢驗 | 105新增送檢群組
    async addExaminationGroupByJson(parameter, progressEvent = null) {
        return this.callApi('post', 'addExaminationGroupByJson', parameter, progressEvent);
    }
    //檢驗 | 106取得送檢中詳細資料
    async getExaminationGroupDetailByExamOutsideId(parameter) {
        return this.callApi('get', 'getExaminationGroupDetailByExamOutsideId', parameter);
    }
    //檢驗 | 107上傳外部檢驗結果
    async updExaminationGroupResult(parameter, progressEvent = null) {
        return this.callApi('post', 'updExaminationGroupResult', parameter, progressEvent);
    }
    //檢驗 | 108上傳內部檢驗結果
    async updExaminationGroupResultInside(parameter, progressEvent = null) {
        return this.callApi('post', 'updExaminationGroupResultInside', parameter, progressEvent);
    }
    //檢驗 | 109取得內部檢驗詳細
    async getExaminationResultInsideDetail(parameter) {
        return this.callApi('get', 'getExaminationResultInsideDetail', parameter);
    }
    //檢驗 | 110取得院內檢驗列表
    async getExamInsideStatusByExamTypeAndKeywordWithPage(parameter) {
        return this.callApi('get', 'getExamInsideStatusByExamTypeAndKeywordWithPage', parameter);
    }
    //檢驗 | 111取得物種檢驗範圍
    async getExaminationSetting(parameter) {
        return this.callApi('get', 'getExaminationSetting', parameter);
    }
    //檢驗 | 112新增物種檢驗範圍
    async addOrUpdExaminationSetting(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrUpdExaminationSetting', parameter, progressEvent);
    }
    //檢驗 | 113取得今日送檢
    async getExamOutsideResultByBookedExamDate(parameter) {
        return this.callApi('get', 'getExamOutsideResultByBookedExamDate', parameter);
    }
    //檢驗 | 114搜尋檢驗紀錄
    async getExaminationByCreateTimeNoPage(parameter) {
        return this.callApi('get', 'getExaminationByCreateTimeNoPage', parameter);
    }
    //檢驗 | 115機器上傳內部檢驗結果
    async updInsideExamFile(parameter, progressEvent = null) {
        return this.callApi('post', 'updInsideExamFile', parameter, progressEvent);
    }
    //檢驗 | 116取得外部檢驗資料
    async getExaminationResultOutsideByOutsideId(parameter) {
        return this.callApi('get', 'getExaminationResultOutsideByOutsideId', parameter);
    }
    //檢驗 | 117更新x光的json
    async updXrayJson(parameter, progressEvent = null) {
        return this.callApi('post', 'updXrayJson', parameter, progressEvent);
    }
    //檢驗 | 118更新檢驗狀態
    async updExaminationResultOutsideIsDisableByPresId(parameter, progressEvent = null) {
        return this.callApi('post', 'updExaminationResultOutsideIsDisableByPresId', parameter, progressEvent);
    }
}
export default Exam;